import request from '@/utils/request'
import { cmsServerContext } from '@/config/config'

/**
 * 支付宝扫码支付返回二维码
 * @param tradeNo
 * @param totalAmount
 * @param meterId
 * @param customerId
 * @param customerUserId
 */
export function aliPay(tradeNo,commandId,totalAmount,meterId,customerId,customerUserId) {
  return request({
    url: cmsServerContext + '/inquiryMachineRecharge/aliPay',
    method: 'post',
    data:{tradeNo:tradeNo,commandId:commandId,totalAmount:totalAmount,meterId:meterId,customerId:customerId,customerUserId:customerUserId}
  })
}

/**
 * 微信扫码支付返回二维码
 * @param tradeNo
 * @param totalAmount
 * @param meterId
 * @param customerId
 * @param customerUserId
 */
export function wxPay(tradeNo,commandId,totalAmount,meterId,customerId,customerUserId) {
  return request({
    url: cmsServerContext + '/inquiryMachineRecharge/wxPay',
    method: 'post',
    data:{tradeNo:tradeNo,commandId:commandId,totalAmount:totalAmount,meterId:meterId,customerId:customerId,customerUserId:customerUserId}
  })
}

/**
 * 根据id查询充值记录
 * @param tradeNo 订单号，即id
 */
export function rechargeResult(tradeNo) {
  return request({
    url: cmsServerContext + '/inquiryMachineRecharge/rechargeResult/' + tradeNo,
    method: 'get'
  })
}